module.exports = __webpack_public_path__ + "assets/img/0613.780a7c72.png";